<template>
  <div>
    <vs-popup :title="popupTitle" :active.sync="showModal">
      <div v-if="showModal">
        <div class="flex flex-col gap-2">
          <div class="w-full flex flex-col">
            <vs-input v-model="model.title" name="title" :label="$t('Title')" />
          </div>
          <div class="w-full flex flex-col">
            <vs-input
              v-model="model.subTitle"
              name="subTitle"
              :label="$t('Subtitle')"
            />
          </div>
          <div class="flex gap-2">
            <div class="flex-grow flex flex-col relative">
              <vs-input
                v-model="model.name"
                name="name"
                :label="$t('Name')"
                v-validate="'required'"
              />
              <span
                class="text-danger text-sm absolute"
                style="top: 32px; right: 10px"
                v-show="errors.has('name')"
                >{{ errors.first("name") }}</span
              >
            </div>
            <div class="flex-grow flex flex-col relative">
              <vs-input
                v-model="model.backgroundColor"
                name="backgroundColor"
                :label="$t('BackgroundColor')"
                class="relative"
                style="direction: rtl"
              />
              <input
                type="color"
                v-model="model.backgroundColor"
                @input="changeBackgroundColor"
                name="colorCode"
                style="bottom: 6px; left: 6px"
                class="absolute h-8 w-24"
              />
            </div>
          </div>
          <div class="w-full flex">
            <vs-textarea
              v-model="model.description"
              name="description"
              :label="$t('Description')"
            />
          </div>
          <div class="w-full flex -mt-4">
            <vs-input
              v-model="model.href"
              name="title"
              :label="$t('Link')"
              class="left-to-right-input"
            />
          </div>
          <div class="w-full flex items-center">
            <vs-checkbox @click.stop="" v-model="model.published"></vs-checkbox>
            <span
              class="mt-1 cursor-pointer"
              @click="model.published = !model.published"
              >{{ $t("Published") }}</span
            >
          </div>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4 mb-8"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss" scoped>
.removeIco {
  float: left !important;
  top: 10px !important;
  left: 10px !important;
}

.left-to-right-input ::v-deep input {
  direction: ltr;
}
</style>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    name: {
      required: "لطفا نام را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content_management_Content_Items_Popup",
  props: {
    show: { default: false },
    modelToEdit: { default: null },
  },
  components: {},
  data() {
    return {
      popupTitle: "",
      model: {
        contentId: this.$route.params.id,
        title: "",
        subTitle: "",
        name: "",
        description: "",
        backgroundColor: "",
        href: "",
        published: false,
      },
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.resetModel();
      },
    },
  },
  methods: {
    ...mapActions({
      createContentItem: "contentType/createContentItem",
      editContentItem: "contentType/editContentItem",
      deleteContentItem: "contentType/deleteContentItem",
    }),
    resetModel() {
      this.model = {
        contentId: this.$route.params.id,
        title: "",
        subTitle: "",
        name: "",
        description: "",
        backgroundColor: "",
        href: "",
        published: false,
      };
    },
    changeBackgroundColor(e) {
      this.model.backgroundColor = e.target.value;
    },
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.modelToEdit && this.modelToEdit.id) {
            const payload = {
              contentId: this.$route.params.id,
              id: this.model.id,
              title: this.model.title,
              subTitle: this.model.subTitle,
              name: this.model.name,
              description: this.model.description,
              backgroundColor: this.model.backgroundColor,
              href: this.model.href,
              published: this.model.published,
            };
            this.editContentItem(payload).then((response) => {
              if (response) {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.model = {};
              }
            });
          } else {
            this.createContentItem(this.model).then((response) => {
              if (response) {
                this.$swal({
                  position: "center-center",
                  type: "success",
                  text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                  showConfirmButton: false,
                  timer: 2000,
                });
                this.$emit("finish");
                this.model = {};
              }
            });
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.$validator.resume();
        if (this.modelToEdit.id) {
          this.model = { ...this.modelToEdit };
          this.popupTitle = "ویرایش آیتم: " + this.model.title;
        } else {
          this.popupTitle = this.$t("CreateNewItem");
        }
        this.model.contentId = this.$route.params.id;
      } else {
        this.$validator.pause();
      }
    },
  },
};
</script>
